import React, { useEffect, useState } from 'react';
import FlexboxGrid from 'rsuite/FlexboxGrid';
import Modal from 'rsuite/Modal';
import List from 'rsuite/List';
import SpinnerIcon from '@rsuite/icons/legacy/Spinner';
import CharacterAuthorizeIcon from '@rsuite/icons/CharacterAuthorize';
import PhoneIcon from '@rsuite/icons/Phone';
import { InputPicker } from 'rsuite';
import IconButton from 'rsuite/IconButton';
import AddOutlineIcon from '@rsuite/icons/AddOutline';
import CloseOutlineIcon from '@rsuite/icons/CloseOutline';
import { useEmpresas } from 'Components/Common/CustomHooks/useEmpresas';
import { Notification, useToaster } from 'rsuite';

import api from 'Components/_helpers/api';

const styleCenter = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '60px',
};

const slimText = {
  fontSize: '0.666em',
  color: '#97969B',
  fontWeight: 'lighter',
  paddingBottom: 5,
};

const titleStyle = {
  paddingBottom: 5,
  whiteSpace: 'nowrap',
  fontWeight: 500,
};

const dataStyle = {
  fontSize: '1.2em',
  fontWeight: 500,
};

export default function EmisoresUserModal(props) {
  const { isOpen, handleClose, usuario } = props;

  const toaster = useToaster();

  const [data, setData] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [selectedEmisor, setSelectedEmisor] = useState({});
  const [empresas, loadingData, featEmpresas] = useEmpresas();

  const onSelectEmisor = (val, item, event) => {
    if (item) {
      setSelectedEmisor(item);
    }
  };

  const getEmisor = (nit) => {
    api
      .get(`/Emisor?nit=${nit}`)
      .then((res) => {
        setData([res.data, ...data]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const deleteUserEmisor = (item) => {
    api
      .post('/User/DelUserEmisor', { nit: item.nit, userId: usuario.id })
      .then((res) => {
        const newData = data.filter((n) => n.nit !== item.nit);
        setData(newData);
        toaster.push(
          <Notification type={'success'} header={`DTE Manager`} closable>
            <p>
              Se eliminó el emisor {item.nombre} del usuario {usuario.nombre}
            </p>
          </Notification>,
          { placement: 'topEnd' }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const configureEmisor = () => {
    if (selectedEmisor.value) {
      if (data.filter((d) => d.nit === selectedEmisor.value).length > 0) return;
      api
        .post('/User/SetEmisor', { nit: selectedEmisor.value, userId: usuario.id })
        .then((res) => {
          setProcessing(false);
          toaster.push(
            <Notification type={'success'} header={`DTE Manager`} closable>
              <p>
                Se agregó el emisor {selectedEmisor.label} al usuario {usuario.nombre}
              </p>
            </Notification>,
            { placement: 'topEnd' }
          );
          getEmisor(selectedEmisor.value);
        })
        .catch((err) => {
          console.log(err);
          setProcessing(false);
        });
    }
  };

  useEffect(() => {
    setData(usuario.emisoresConfigurados ?? []);
  }, [usuario]);

  return (
    <Modal open={isOpen} size={'lg'} backdrop="static" keyboard={false} onClose={handleClose}>
      <Modal.Header>
        <Modal.Title>Emisores configurados para este usuario ({usuario.nombre})</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FlexboxGrid>
          <FlexboxGrid.Item colspan={18}>
            <InputPicker
              data={empresas}
              placeholder="Selecciona el emisor que quieres configurar a este usuario..."
              block
              valueKey="emisor"
              onSearch={featEmpresas}
              onSelect={onSelectEmisor}
              renderMenu={(menu) => {
                if (loadingData) {
                  return (
                    <p style={{ padding: 10, color: '#999', textAlign: 'center' }}>
                      <SpinnerIcon spin /> Buscando...
                    </p>
                  );
                }
                return menu;
              }}
            />
          </FlexboxGrid.Item>
          <FlexboxGrid.Item colspan={6}>
            <IconButton
              appearance="primary"
              icon={<AddOutlineIcon />}
              style={{ marginLeft: 10 }}
              onClick={configureEmisor}
              loading={processing}
            >
              Agregar emisor
            </IconButton>
          </FlexboxGrid.Item>
        </FlexboxGrid>
        <hr />
        <List hover>
          {data.map((item, index) => (
            <List.Item key={item['nrc']} index={index + 1}>
              <FlexboxGrid>
                <FlexboxGrid.Item colspan={2} style={styleCenter}>
                  <CharacterAuthorizeIcon
                    style={{
                      color: 'darkgrey',
                      fontSize: '1.5em',
                    }}
                  />
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  colspan={6}
                  style={{
                    ...styleCenter,
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                    overflow: 'hidden',
                  }}
                >
                  <div style={titleStyle}>{item['nombre']}</div>
                  <div style={slimText}>
                    <div>
                      <PhoneIcon />
                      {' ' + item['telefono']}
                    </div>
                    <div>{item['correo']}</div>
                  </div>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={6} style={styleCenter}>
                  <div style={{ textAlign: 'right' }}>
                    <div style={slimText}>NIT</div>
                    <div style={dataStyle}>{item['nit'].toLocaleString()}</div>
                  </div>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item colspan={6} style={styleCenter}>
                  <div style={{ textAlign: 'right' }}>
                    <div style={slimText}>NRC</div>
                    <div style={dataStyle}>{item['nrc'].toLocaleString()}</div>
                  </div>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  colspan={4}
                  style={{
                    ...styleCenter,
                  }}
                >
                  <IconButton color="red" appearance={'ghost'} icon={<CloseOutlineIcon />} onClick={() => deleteUserEmisor(item)}>
                    Quitar Emisor
                  </IconButton>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
          ))}
        </List>
      </Modal.Body>
      <Modal.Footer></Modal.Footer>
    </Modal>
  );
}
